export const dayPlannerKeys = {
  all: ['dayPlanner'] as const,
  today: () => [...dayPlannerKeys.all, 'today'] as const,
};

export const calendarKeys = {
  all: ['calendar'] as const,
  subscriptions: () => [...calendarKeys.all, 'subscriptions'] as const,
};

export const habitKeys = {
  all: ['habits'] as const,
  list: () => [...habitKeys.all, 'list'] as const,
};

export const projectKeys = {
  all: ['projects'] as const,
  list: () => [...projectKeys.all, 'list'] as const,
};
